module.exports = __webpack_public_path__ + "static/logos/snow-icon-2493d7127632dbb07281a9afe87dd6b4.svg";